import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

type LocalizedDatePickerProviderProps = {
  children: ReactNode;
};

const LocalizedDatePickerProvider: React.FC<LocalizedDatePickerProviderProps> = (props: LocalizedDatePickerProviderProps) => {
  const { children } = props;
  const { i18n } = useTranslation();
  const language = i18n.resolvedLanguage || i18n.language;

  return (
    <LocalizationProvider dateAdapter={AdapterLuxon} adapterLocale={language}>
      {children}
    </LocalizationProvider>
  );
};

export default LocalizedDatePickerProvider;
